import mapboxgl from 'mapbox-gl'
import moment from 'moment-mini'
import i18n from "../../i18n";
import { getDateTimeFormat } from '../dateFormat'

export class ContactPlacePopup extends mapboxgl.Popup {
  constructor(openTableCallback, statusColors, options) {
    let popupOptions = {
      ...options,
      closeOnMove: false,
      closeOnClick: true,
      closeButton: true,
      className: 'contact-popup',
      maxWidth: '450px'
    }
    super(popupOptions)
    this._openTableCallback = openTableCallback
    this.statusColors = statusColors
  }
  openTable(patientId) {
    this._openTableCallback(patientId)
  }
  addPatientToList(control, patient) {
    let color = this.statusColors[patient.status];
    color = color || 'black'
    let row = document.createElement('div')
    row.className = "contact-popup-row"
    let box = document.createElement('span')
    box.className = "contact-popup-color-box"
    box.setAttribute("style", "background-color: " + color + ";")
    let patientName = document.createElement('span')
    patientName.className = "contact-popup-patient-name"
    if (patient.atPlace) {
      patientName.className += " in-place"
      patientName.title = `${i18n.t('He/She is currently here.')}`
    }
    patientName.innerHTML = patient.azon
    let tableViewButton = document.createElement('span')
    tableViewButton.className = "contact-table-view v-icon notranslate mdi mdi-note"
    tableViewButton.title = `${i18n.t('Open')}`
    tableViewButton.addEventListener('click', (e) => { this.openTable(patient.id); e.stopPropagation(); return false; })
    let patientDate = document.createElement('span')
    patientDate.className = "contact-popup-patient-date"
    patientDate.innerHTML = moment(patient.dates[patient.dates.length - 1].from).format(getDateTimeFormat())
    row.appendChild(box)
    row.appendChild(patientName)
    row.appendChild(patientDate)
    row.appendChild(tableViewButton)
    control.appendChild(row)
  }
  generateContactControl(place) {
    let control = document.createElement('div')
    control.className = "contact-popup-content"
    let addressDiv = document.createElement('div')
    addressDiv.className = "contact-popup-address"
    addressDiv.innerText = place.addresses && place.addresses.length > 0 ? place.addresses[0] : ""
    let header = document.createElement('div')
    header.className = "contact-popup-header"
    header.innerText = `${i18n.t('Persons')}:`
    let tableContainer = document.createElement('div')
    tableContainer.className = "contact-popup-table-container"
    let table = document.createElement('div')
    table.className = "contact-popup-table"
    control.appendChild(addressDiv)
    control.appendChild(header)
    place.contacts.sort((a, b) => {
      if (a.atPlace && !b.atPlace)
        return 1;
      if (!a.atPlace && b.atPlace)
        return -1;
      if (a.azon < b.azon)
        return -1;
      return 1;
    })
    for (let patient of place.contacts) {
      this.addPatientToList(table, patient)
    }
    tableContainer.appendChild(table)
    control.appendChild(tableContainer)
    return control
  }
  open(map, place) {
    if (this.isOpen()) {
      this.remove()
    }
    if (place) {
      let control = this.generateContactControl(place)
      this.setDOMContent(control)
      this.setLngLat(place.point.coordinates)
      this.addTo(map)
    }
  }
}
